import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { generatePath, useHistory, useRouteMatch } from 'react-router-dom';
import * as finderActions from '../../finder/actions';
import { getData, getDetails, getNavigation, getIsOriginalView } from '../../finder/selectors';
import { routes } from '../../router/model';
import '../style.scss';
import { BasePreview } from './BasePreview';

export const AssetLabFullscreenPreview: React.FC<{ back: string }> = ({ back }) => {
  const nav = useSelector(getNavigation);
  const { assets } = useSelector(getData);
  const error = useSelector(getDetails).error;
  const dispatch = useDispatch();
  const history = useHistory();
  const loc = useRouteMatch<{ assetID: string; sharingId?: string }>(back + routes.preview);
  const assetIDInLocation = parseInt(loc?.params.assetID ?? '', 10);
  const currID = nav.curr?.id;
  const sharingId = loc?.params.sharingId;

  useEffect(() => {
    if (assets.length !== 0 && assetIDInLocation !== currID) {
      // Ассеты загружены, но URL и selectedID не соответствуют друг другу

      if (currID !== undefined) {
        // у нас существует выбранный ассет, а значит он выбран пользователем, слушаемся его и меняем урл
        history.replace(
          generatePath(back + routes.preview, {
            assetID: currID,
            sharingId,
          }),
        );
      } else {
        // currID === undefined, а значит страница была только что загружена
        dispatch(
          finderActions.assetSelected({
            ids: [assetIDInLocation],
            firstId: assetIDInLocation,
            lastId: assetIDInLocation,
          }),
        );
      }
    }
  }, [assets, assetIDInLocation, currID, sharingId, dispatch, history, back]);

  const onNext =
    nav.next !== null
      ? () =>
          nav.next &&
          dispatch(
            finderActions.assetSelected({
              ids: [nav.next.id],
              firstId: nav.next.id,
              lastId: nav.next.id,
            }),
          )
      : undefined;

  const onPrev =
    nav.prev !== null
      ? () =>
          nav.prev &&
          dispatch(
            finderActions.assetSelected({
              ids: [nav.prev.id],
              firstId: nav.prev.id,
              lastId: nav.prev.id,
            }),
          )
      : undefined;

  const isOriginalView = useSelector(getIsOriginalView);

  return (
    <BasePreview
      back={back}
      asset={nav.curr}
      error={error}
      onNext={onNext}
      onPrev={onPrev}
      originalView={{
        isEnabled: isOriginalView,
        enable: () => dispatch(finderActions.originalViewEnabled()),
      }}
    />
  );
};
